export default {
	/* Courses  */
	classPackage: 'Packages',
	pendingCourses: 'Clases Pendientes',
	coursesFinished: 'Clases Terminadas',
	installZOOM: 'Instalar ZOOM',
	more: 'Más',
	enter: 'Ingresar',
	download: 'Descargar',
	cancel: 'Cancelar',
	notice: 'Notificación',
	ok: 'Ok',
	zoomTip: 'Por favor, instala ZOOM para poder tener la clase.',
	noticeTip:
		'Por favor, abre la aplicación de Estudiante de AirClass para ver el reporte y videos de las clases. Puedes hacer clic en el botón de abajo para descargar.',
	noticeTip2:
		'Por favor, únete a nuestra aula de clases online en nuestra aplicación de Estudiante de AirClass. Puedes hacer clic en el botón de abajo para descargar.',
	zoomNoticeTip: 'El aula se abrirá 20 minutos antes del comienzo de la clase',
	airClassNoticeTip: 'El aula se abrirá 20 minutos antes del comienzo de la clase',
	monthData: {
		'01': 'Enero',
		'02': 'Febrero',
		'03': 'Marzo',
		'04': 'Abril',
		'05': 'Mayo',
		'06': 'Junio',
		'07': 'Julio',
		'08': 'Agosto',
		'09': 'Septiembre',
		'10': 'Octubre',
		'11': 'Noviembre',
		'12': 'Diciembre',
	},
	lessonType: ['', 'Clase de prueba', 'Clase regular', 'tiempo de prueba del dispositivo'],
	coursesEmpty: 'Aún no tienes clase',
	startIn: 'Empezar en',

	/* Profile Information */
	courses: 'Clases',
	ProfileInfor: 'Información de perfil',
	TransRecord: 'Registro de la transacción',
	/* Transation Record */
};
